<div class="container" style="max-width: 900px; margin-left: 0">
  <div class="row">
    <div class="col-12 mt-2">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'Turbo.Settings.RightsManagement.UserSettings' | translate : 'User settings' }}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12">
              <h1>{{ 'Turbo.Settings.RightsManagement.UserSettings' | translate : 'User settings' }}</h1>
            </div>
            <div class="col-12">
              <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
                <mat-label>{{ 'Turbo.Settings.RightsManagement.UserName' | translate : 'Username' }}</mat-label>
                <input required #txtUsername="ngModel" matInput placeholder="{{ 'Turbo.Settings.RightsManagement.UserName' | translate : 'Username' }}" [(ngModel)]="_user.Username" [disabled]="!editable || !newUser">
              </mat-form-field>
            </div>
          </div>
          <div class="row" *ngIf="newUser">
            <div class="col-12">
              <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
                <mat-label>{{ 'Turbo.Settings.RightsManagement.Password' | translate : 'Password' }}</mat-label>
                <input required #txtPassword="ngModel" matInput type="password" placeholder="{{ 'Turbo.Settings.RightsManagement.Password' | translate : 'Password' }}" [(ngModel)]="password" [disabled]="!editable">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
                <mat-label>{{ 'Turbo.Settings.RightsManagement.Email' | translate : 'Email' }}</mat-label>
                <input #txtEmail="ngModel" matInput placeholder="{{ 'Turbo.Settings.RightsManagement.Email' | translate : 'Email' }}" [(ngModel)]="_user.Email" [disabled]="!editable">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
                <mat-label>{{ 'Turbo.Settings.RightsManagement.PhoneNumber' | translate : 'Phone number' }}</mat-label>
                <input #txtMobilePhone="ngModel" matInput placeholder="{{ 'Turbo.Settings.RightsManagement.PhoneNumber' | translate : 'Phone number' }}" [(ngModel)]="_user.Phone" [disabled]="!editable">
              </mat-form-field>
            </div>
            <div class="col-12" *ngIf="Settings.isInAny(['BackOffice', 'Admin'], true)">
              <mat-form-field appearance="fill">
                <mat-label>{{ 'Turbo.Settings.Groups' | translate : 'Groups' }}</mat-label>
                <mat-select [(ngModel)]="userRoles" multiple>
                  <mat-option *ngFor="let role of roles" [value]="role.Id">
                    {{role.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-12" *ngIf="Settings.isInAny(['BackOffice', 'Admin'], true)">

              <mat-form-field appearance="outline">
                <mat-label>Serviceguy</mat-label>
                <input matInput placeholder="Search for Service guy" [matAutocomplete]="auto" [formControl]="txtServiceGuy" [ngModel]="formattedServiceGuy">
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let guy of filteredServiceGuys | async" [value]="(guy.Companyname ? guy.Companyname: '') + ' - ' + (guy.Firstname ? guy.Firstname: '') + ' ' + (guy.Lastname ? guy.Lastname  : '') + ' - ' + (guy.Email ? guy.Email : '') + ' - ' + (guy.Phone ? guy.Phone : '')" (onSelectionChange)="selectedServiceGuy(guy)">
                    <span *ngIf="guy.Companyname">{{guy.Companyname}} - </span><span *ngIf="guy.Firstname">{{guy.Firstname}} </span><span *ngIf="guy.Lastname">{{guy.Lastname}} - </span><span *ngIf="guy.Email">{{guy.Email}} - </span> <span *ngIf="guy.Phone">{{guy.Phone}}</span>
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="Settings?.getUser()?.Impersonating && Settings.isInAny(['BackOffice', 'Admin'], true)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'Turbo.Settings.RightsManagement.DeveloperOptions' | translate : 'Developer options' }}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
                <mat-label>Context id</mat-label>
                <input #txtContextId="ngModel" matInput placeholder="Context id" [(ngModel)]="_user.ContextId" [disabled]="!editable">
              </mat-form-field>
            </div>
            <div class="col-6 mb-2" *ngIf="manager">
              <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
                <mat-label>Manager</mat-label>
                <input #txtManager="ngModel" matInput placeholder="Manager" [(ngModel)]="manager" [disabled]="true">
                <mat-icon matSuffix (click)="changeManager()" style="cursor: pointer;">mode_edit</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-6" style="line-height: 60px">
              <mat-checkbox [disabled]="!editable" [ngModel]="_user.IsApi" #api (change)="setApi(api.checked)">API User</mat-checkbox>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
</div>
  </div>
  <div *ngIf="false">
    <div class="row">
      <div class="col-12">
        <h1>{{ 'Turbo.Settings.RightsManagement.UserSettings' | translate : 'User settings' }}</h1>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
          <mat-label>{{ 'Turbo.Settings.RightsManagement.UserName' | translate : 'Username' }}</mat-label>
          <input required #txtUsername="ngModel" matInput placeholder="{{ 'Turbo.Settings.RightsManagement.UserName' | translate : 'Username' }}" [(ngModel)]="_user.Username" [disabled]="!editable || !newUser">
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="newUser">
      <div class="col-12">
        <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
          <mat-label>{{ 'Turbo.Settings.RightsManagement.Password' | translate : 'Password' }}</mat-label>
          <input required #txtPassword="ngModel" matInput type="password" placeholder="{{ 'Turbo.Settings.RightsManagement.Password' | translate : 'Password' }}" [(ngModel)]="password" [disabled]="!editable">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
          <mat-label>{{ 'Turbo.Settings.RightsManagement.Email' | translate : 'Email' }}</mat-label>
          <input #txtEmail="ngModel" matInput placeholder="{{ 'Turbo.Settings.RightsManagement.Email' | translate : 'Email' }}" [(ngModel)]="_user.Email" [disabled]="!editable">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
          <mat-label>{{ 'Turbo.Settings.RightsManagement.PhoneNumber' | translate : 'Phone number' }}</mat-label>
          <input #txtMobilePhone="ngModel" matInput placeholder="{{ 'Turbo.Settings.RightsManagement.PhoneNumber' | translate : 'Phone number' }}" [(ngModel)]="_user.Phone" [disabled]="!editable">
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="fill">
          <mat-label>{{ 'Turbo.Settings.Groups' | translate : 'Groups' }}</mat-label>
          <mat-select [(ngModel)]="userRoles" multiple>
            <mat-option *ngFor="let role of roles" [value]="role.Id">
              {{role.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 mt-4">
        <h1>Developer options</h1>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" *ngIf="_user && (_user.Username || newUser)">
          <mat-label>Context id</mat-label>
          <input #txtContextId="ngModel" matInput placeholder="Context id" [(ngModel)]="_user.ContextId" [disabled]="!editable">
        </mat-form-field>
      </div>
      <div class="col-12">
        Manager: {{ manager }} - <a routerLink="">Change</a>
      </div>
      <div class="col-12">
        <mat-checkbox [disabled]="!editable" [ngModel]="_user.IsApi" #api (change)="setApi(api.checked)">API User</mat-checkbox>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col-2" style="text-align: left; padding-left: 5px; padding-right: 5px;">
      <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()" [disabled]="(this.newUser && this.password.length == 0 || (this._user && this._user.Username && this._user.Username.length == 0))">
        <span *ngIf="!newUser">{{'Turbo.OneWayAdmin.UserManagement.Actions.cmdSave' | translate : 'Save' }}</span>
        <span *ngIf="newUser">{{'Turbo.OneWayAdmin.ServiceDialog.Actions.cmdCreate' | translate : 'Create' }}</span>
      </button>
    </div>
    <div class="col-10" style="text-align: right; padding-left: 5px; padding-right: 5px;" *ngIf="!newUser">
      <button mat-stroked-button style="margin: 3px;" (click)="changePassword()">
        <mat-icon>edit</mat-icon>
        {{'Turbo.OneWayAdmin.ServiceDialog.Actions.cmdChangePassword' | translate : 'Change password' }}
      </button>
      <button mat-stroked-button style="margin: 3px;" (click)="resetPassword()" *ngIf="!newUser && Settings.isInAny(['BackOffice', 'Admin'], true)">
        <mat-icon>restart_alt</mat-icon>
        {{'Turbo.OneWayAdmin.ServiceDialog.Actions.cmdResetPassword' | translate : 'Reset password' }}
      </button>
      <button mat-stroked-button style="margin: 3px;" (click)="removeUser()" *ngIf="Settings.isInAny(['BackOffice', 'Admin'], true)">
        <mat-icon>delete</mat-icon>
        {{'Turbo.OneWayAdmin.ServiceDialog.Actions.cmdRemove' | translate : 'Remove user' }}
      </button>
    </div>
  </div>  
</div>
